var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.11765C0 0.948529 0.948529 0 2.11765 0H4.23529C5.01618 0 5.64706 0.630882 5.64706 1.41176C5.64706 2.19265 5.01618 2.82353 4.23529 2.82353H2.82353V8.47059C2.82353 10.8088 4.72059 12.7059 7.05882 12.7059C9.39706 12.7059 11.2941 10.8088 11.2941 8.47059V2.82353H9.88235C9.10147 2.82353 8.47059 2.19265 8.47059 1.41176C8.47059 0.630882 9.10147 0 9.88235 0H12C13.1691 0 14.1176 0.948529 14.1176 2.11765V8.47059C14.1176 11.8853 11.6912 14.7353 8.47059 15.3882V16.2353C8.47059 18.9662 10.6809 21.1765 13.4118 21.1765C16.1426 21.1765 18.3529 18.9662 18.3529 16.2353V12.4632C16.7074 11.8809 15.5294 10.3147 15.5294 8.47059C15.5294 6.13235 17.4265 4.23529 19.7647 4.23529C22.1029 4.23529 24 6.13235 24 8.47059C24 10.3147 22.8221 11.8853 21.1765 12.4632V16.2353C21.1765 20.5235 17.7 24 13.4118 24C9.12353 24 5.64706 20.5235 5.64706 16.2353V15.3882C2.42647 14.7353 0 11.8853 0 8.47059V2.11765ZM19.7647 9.88235C20.5456 9.88235 21.1765 9.25147 21.1765 8.47059C21.1765 7.68971 20.5456 7.05882 19.7647 7.05882C18.9838 7.05882 18.3529 7.68971 18.3529 8.47059C18.3529 9.25147 18.9838 9.88235 19.7647 9.88235Z",
    fill: "#D9808A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScope);
export default __webpack_public_path__ + "static/media/scope.a6caebf8fb755b1d4fc46ab1ed1949a0.svg";
export { ForwardRef as ReactComponent };